import {Injectable} from '@angular/core';
import {IServiceRoute} from '@core/model';
import {OAServices} from '@core/enums';
import {Subject} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class SoftwareService {

  scrollToUploadSection$: Subject<void> = new Subject<void>();

  public serviceRoutes: IServiceRoute[] = [
    {
      name: OAServices.AutoSlicer,
      route: '/auto-slicer'
    },
    {
      name: OAServices.BatchNormalizer,
      route: '/normalizer'
    },
    {
      name: OAServices.SoundSeparator,
      route: '/stem-isolator'
    },
    {
      name: OAServices.FileConverter,
      route: '/file-converter'
    },
    /*{
      name: OAServices.DrumSynthesizer,
      route: '/drum-synthesizer'
    }, */
    {
      name: OAServices.DrumOrganizer,
      route: '/drum-organizer'
    }
  ];


  constructor() {

  }
}
